import ProductMobileDetail from '@/components/ProductMobile/ProductMobileDetail'

let ProductMobileRouter = [{
  path: '/product_mobile/:id',
  name: 'ProductMobileDetail',
  component: ProductMobileDetail,
  meta: {
    title: 'Fiche produit',
    requiresAuth: true,
    authorizations: ['product_show', 'mobile_access']
  }
}]

export default ProductMobileRouter



// WEBPACK FOOTER //
// ./src/components/ProductMobile/router.js